module.exports = __webpack_public_path__ + "media/images/order/waiting_approve-7de91873b51e6e9ccefb91d1334d85af.jpg";